import axiosInstance from '@/utils/axiosInstance';
import { getAuthHeaders } from '@/utils/api';
import { API_ENDPOINTS, buildUrl, buildVendorHeaders, QUERY_PARAMS } from '@/constant/constant';
import { API_URL } from '@/constant/constant';
import { USER_ROLES } from '../../../constant/constant';

// Shop API functions
export const inventoryApi = {
  // Orders API
  fetchOrdersByStatus: async (vendorId, status) => {
    try {
      const url = buildUrl(API_ENDPOINTS.ORDERS.VENDOR, {
        [QUERY_PARAMS.STATUS]: status,
        [QUERY_PARAMS.INTEGER]: 0,
      });
      const response = await axiosInstance.get(url, {
        headers: buildVendorHeaders(vendorId, getAuthHeaders()),
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching orders:', error);
      return { success: false, error: error.message };
    }
  },

  // Categories API
  fetchCategories: async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL.BASE_PRODUCT}/rest/big-local/api/v1/category`,
        {
          headers: {
            ...getAuthHeaders(),
            'X-USER-ROLE': USER_ROLES.VENDOR,
          },
        }
      );
      return { success: true, data: response?.data };
    } catch (error) {
      console.error('Error fetching categories:', error);
      return { success: false, error: error.message };
    }
  },

  // Products API
  fetchProductsByCategory: async (vendorId, categoryId, subCategoryId = null) => {
    try {
      const response = await axiosInstance.get(
        `${API_URL.BASE_VENDOR}/rest/big-local/api/v1/vendor/products?categoryId=${subCategoryId}`,
        {
          headers: {
            ...getAuthHeaders(),
            'X-USER-ROLE': USER_ROLES.VENDOR,
            'X-Vendor-Id': vendorId,
          },
        }
      );

      // Process the data to ensure consistent price fields
      const processedData = response.data?.map((product) => ({
        ...product,
        mrp: product.mrp || product.netPrice || 0,
        netPrice: product.netPrice || product.mrp || 0,
      }));

      return { success: true, data: processedData };
    } catch (error) {
      console.error('Error fetching products:', error);
      return { success: false, error: error.message };
    }
  },

  // Update product prices and availability
  updateProducts: async (vendorId, products) => {
    try {
      const response = await axiosInstance.put(buildUrl(API_ENDPOINTS.PRODUCTS.VENDOR), products, {
        headers: buildVendorHeaders(vendorId, getAuthHeaders()),
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating products:', error);
      return { success: false, error: error.message };
    }
  },
};

export const processOrderData = (orders, status) => {
  console.log(status);
  return orders;
};

// Enhanced function to handle mixed categories/subcategories
export const filterVendorCategories = (categories, vendorCategories = []) => {
  if (!vendorCategories || vendorCategories.length === 0) {
    return categories;
  }

  return categories
    .filter((category) => {
      // Check if the main category is in vendor categories
      const isCategoryIncluded = vendorCategories.includes(category.name);

      // Check if any subcategory is in vendor categories
      const hasIncludedSubcategory = category.subCategories?.some((subCategory) =>
        vendorCategories.includes(subCategory.name)
      );

      // Include category if either the main category or any subcategory is included
      if (isCategoryIncluded || hasIncludedSubcategory) {
        // If only subcategories are included, filter them
        if (!isCategoryIncluded && hasIncludedSubcategory) {
          return {
            ...category,
            subCategories: category.subCategories?.filter((subCategory) =>
              vendorCategories.includes(subCategory.name)
            ),
          };
        }
        return true;
      }

      return false;
    })
    .map((category) => {
      // If the main category is not included but subcategories are, filter subcategories
      if (!vendorCategories.includes(category.name) && category.subCategories) {
        return {
          ...category,
          subCategories: category.subCategories.filter((subCategory) =>
            vendorCategories.includes(subCategory.name)
          ),
        };
      }
      return category;
    });
};

export const prepareProductUpdateData = (products, changedItems) => {
  return products
    .filter((product) => changedItems.has(product.productId))
    .map((product) => ({
      productId: product.productId,
      netPrice: product.netPrice,
      mrp: product.mrp,
      available: product.available,
    }));
};
